var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useEffect, useState } from 'react';
import { store } from '../../store';
import { sendWebsocketMessage } from '../websocket';
import { DataMessage, DataMsgBodyType, DataMsgType, } from '../proto/plugnmeet_datamessage_pb';
const useWatchVisibilityChange = () => {
    _react_refresh_temp_1();
    const [hidden, setHidden] = useState(false);
    useEffect(() => {
        const onBlur = () => {
            setHidden(true);
        };
        const onFocus = () => {
            setHidden(false);
        };
        window.addEventListener('blur', onBlur, false);
        window.addEventListener('focus', onFocus, false);
        return () => {
            window.removeEventListener('blur', onBlur);
            window.removeEventListener('focus', onFocus);
        };
    }, []);
    // in mobile sometime above solution doesn't work properly
    useEffect(() => {
        let hidden, visibilityChange;
        if (typeof document.hidden !== 'undefined') {
            // Opera 12.10 and Firefox 18 and later support
            hidden = 'hidden';
            visibilityChange = 'visibilitychange';
        }
        else if (typeof document.msHidden !== 'undefined') {
            hidden = 'msHidden';
            visibilityChange = 'msvisibilitychange';
        }
        else if (typeof document.webkitHidden !== 'undefined') {
            hidden = 'webkitHidden';
            visibilityChange = 'webkitvisibilitychange';
        }
        const handleVisibilityChange = () => {
            if (document[hidden]) {
                setHidden(true);
            }
            else {
                setHidden(false);
            }
        };
        if (typeof document.addEventListener !== 'undefined' ||
            hidden !== undefined) {
            document.addEventListener(visibilityChange, handleVisibilityChange, false);
        }
        return () => {
            if (typeof document.addEventListener !== 'undefined' ||
                hidden !== undefined) {
                document.removeEventListener(visibilityChange, handleVisibilityChange);
            }
        };
    }, []);
    useEffect(() => {
        var _a, _b, _c, _d;
        const session = store.getState().session;
        const dataMsg = new DataMessage({
            type: DataMsgType.SYSTEM,
            roomSid: session.currentRoom.sid,
            roomId: session.currentRoom.room_id,
            body: {
                type: DataMsgBodyType.USER_VISIBILITY_CHANGE,
                from: {
                    sid: (_b = (_a = session.currentUser) === null || _a === void 0 ? void 0 : _a.sid) !== null && _b !== void 0 ? _b : '',
                    userId: (_d = (_c = session.currentUser) === null || _c === void 0 ? void 0 : _c.userId) !== null && _d !== void 0 ? _d : '',
                },
                msg: hidden ? 'hidden' : 'visible',
            },
        });
        sendWebsocketMessage(dataMsg.toBinary());
    }, [hidden]);
};
_react_refresh_temp_1(useWatchVisibilityChange, "Tkte8x8CJIhrzdRODc4VPJ4mCcE=");
export default useWatchVisibilityChange;
